const HTTP = {
  ContentTypes: {
    FormUrlEncoded: 'application/x-www-form-urlencoded',
    JSON: 'application/json',
  },
}

export default HTTP
